<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>
		<van-form @submit="onSubmit">
			<van-field v-model="name" label="收款人" placeholder="请输入收款人" />

			<van-field v-model="username" label="账号" placeholder="请输入收款账号" />

			<van-field v-model="money" label="金额" placeholder="请输入金额" type="number" />

			<van-field v-model="text" label="备注" placeholder="请输入内容" type="textarea" />

			<!-- <van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader :after-read="afterRead" />
				</template>
			</van-field> -->

			<van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader v-model="uploader" :max-count="6" accept="all" multiple />
				</template>
			</van-field>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">提交</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { Toast } from "vant";
// import { post } from "@/api/post";
import { getToken } from "@/utils/auth";
import axios from "axios";

export default {
	components: {
		navbar,
	},
	data() {
		return {
			title: "支付",
			name: "",
			username: "",
			money: "",
			text: "",
			uploader: [],
		};
	},
	mounted() {
		console.log(this.$route.query);
	},
	methods: {
		onSubmit() {
			// let result = {
			// 	requestType: "purchase_order_approval",
			// 	purchase_id: this.$route.query.purchase_id,
			// 	purchase_status: 1,
			// 	receiving_account: this.username,
			// 	chamberlain: this.name,
			// 	amount: this.money,
			// 	remark: this.text,
			// 	file: this.uploader,
			// };
			// console.log(result);
			// post(result)
			// 	.then(() => {
			// 		// this.$route.params.listRefresh = true;
			// 		this.$router.go(-2);
			// 		return Toast.success("审核成功!");
			// 	})
			// 	.catch(() => {
			// 		return Toast.fail("数据异常");
			// 	});

			let that = this;
			let formData = new FormData();
			for (let i = 0; i < this.uploader.length; i++) {
				formData.append("file", this.uploader[i].file);
			}
			formData.append("purchase_id", this.$route.query.purchase_id);
			formData.append("requestType", "purchase_order_approval");
			formData.append("purchase_status", 1);
			formData.append("receiving_account", this.username);
			formData.append("chamberlain", this.name);
			formData.append("amount", this.money);
			formData.append("remark", this.text);
			formData.append("token", getToken());
			const config = {
				timeout: 60 * 1000,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};
			this.signTime = false;
			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then((res) => {
					console.log(res);
					if (res.data.code === 200) {
						this.$route.params.listRefresh = true;
						this.$router.go(-2);
						Toast.fail("确认成功完成!");
					} else if (res.data.code === 300) {
						this.$router.push({
							path: "/login",
						});
					} else {
						Toast.fail("网路连接错误,请稍后重试!");
					}
				})
				.catch((err) => {
					console.log(err);
					that.signTime = true;
					let text = "当前网络环境差,请重新提交!";
					this.$toast.fail(text);
				});
		},
		afterRead(file) {
			// 此时可以自行将文件上传至服务器
			console.log(file);
			this.uploader = file;
			Toast.success("上传成功!");
		},
		
	},
};
</script>

<style lang="scss" scoped></style>
